var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{
    path: '/login',
    query: Object.assign({}, _vm.$route.query,
        _vm.originQuery)
}}},[_c('i',{staticClass:"fa fa-angle-left nav-back-btn"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }